<template>
  <b-modal
    id="uncollect-money"
    modal-class="modal-style two-footer-btn"
    ref="modal"
  >
    <!-- //TODO: currency format -->
    <template>
      <p class="modal-style-title modal-title">
        尚有未收金額 ${{ unpaidAmount }}
      </p>
      <div class="modal-style-content">
        <p>
          請確認是否收款
        </p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="transparent-btn" @click="$bvModal.hide(`uncollect-money`)">
        取消
      </button>
      <button class="custom-btn" @click="handlePay">
        確認
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    unpaidAmount: {
      required: false,
      type: Number,
      default() {
        return 0;
      }
    }
  },
  methods: {
    handlePay() {
      this.$emit('handlePay');
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-title {
  color: #ff0000;
}
</style>
